import { render, staticRenderFns } from "./WorkgroupOrderDetail.vue?vue&type=template&id=acbf58c6&scoped=true"
import script from "./WorkgroupOrderDetail.vue?vue&type=script&lang=js"
export * from "./WorkgroupOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkgroupOrderDetail.vue?vue&type=style&index=0&id=acbf58c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbf58c6",
  null
  
)

export default component.exports